<template>
  <div class='account-container 1_2'>
    <h2 class='font-500 auth-page-title'>{{ $t('account.main-account') }}</h2>
    <div class='balanceRow' >
        <balance-card />
        <balance-card :isNominal='false' :account="iban"/>
<!--        <balance-card :isNominal='false'/>-->
    </div>
    <h3
      v-if='
        remoteBalance && Array.isArray(remoteBalance) && remoteBalance.length
      '
      class='font-500 pt-5'
    >
      {{ $t('account.slotted-account', { type: $t('cashout.type.type2') }) }}
    </h3>

    <div class='auth-page-section d-flex flex-column' v-if='
          remoteBalance && Array.isArray(remoteBalance) && remoteBalance.length
        '>
      <b-overlay
        :show="remoteBalanceLoading"
        rounded
        opacity="0.6"
        spinner
        spinner-variant="primary"
        class="recent-trades"
        @hidden="!remoteBalanceLoading"
      >
        <div
          class='account'
        >
          <table ref='accountTable' class='ic-table'>
            <thead>
            <tr>
              <th>№</th>
              <th>{{ $t('mse.business-type') }}</th>
              <th class='right'>{{ $t('mse.balance') }}</th>
              <!--              <th>{{ $t('mse.balance-code') }}</th>-->
            </tr>
            </thead>
            <tbody>
            <tr v-for='(item, index) in remoteBalance' :key='index'>
              <td>{{ index + 1 }}.</td>
              <td>{{ item.BalanceDescription }}</td>
              <td class='right'>{{ item.Balance | currency('', '') }}</td>
              <!--              <td>{{ item.BalanceCode }}</td>-->
            </tr>
            </tbody>
          </table>
        </div>
        <ic-button class='mt-4 align-self-end grey'
                   type='button'
                   color='secondary'
                   size='tn'
                   :disabled='downloadDisabled.account'
                   @click='downloadAccountTable'>
          <i class='fas fa-download mr-2' />
          {{ $t('helper.save') }}
        </ic-button>
      </b-overlay>
    </div>

    <h3
      v-if='showShareSection'
      class='font-500 pt-5'
    >
      Хувьцаа
    </h3>
    <div
      v-if='showShareSection'
      class='auth-page-section d-flex flex-column'
    >
      <loader-block v-if='loadingStatus' :loading='true' />
      <template v-else>
      <div class='table-container'>
        <table class='ic-table'>
          <thead>
          <tr>
            <th>{{ $t('brand.symbol.title') }}</th>
            <th class='right'>{{ $t('brand.symbol.total') }}</th>
            <th class='right'>{{ $t('account.held') }}</th>
            <th class='right'>{{ $t('account.available') }}</th>
            <th>{{ $t('account.stype') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for='(item, index) in shareBalance' :key='index'>
            <td>
              <p class='symbol'>{{ item.symbol | symbol }} <span class="exchange-code">/ {{ item.exchange_server_code ?? '--' }}</span></p>
              <p class='name'>{{ item.name }}</p>
            </td>
            <td class='right'>{{ item.value || 0 }}</td>
            <td class='right'>{{ item.hold || 0 }}</td>
            <td class='right'>{{ item.available || item.value - (item.hold || 0) }}</td>
            <td v-if='item.stype === 1'>{{ $t('account.stock') }}</td>
            <td v-if='item.stype !== 1'>{{ $t('account.bond') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ic-button class='mt-4 align-self-end grey'
                 type='button'
                 color='secondary'
                 size='tn'
                 :disabled='downloadDisabled.stock'
                 @click='downloadStockTable'>
        <i class='fas fa-download mr-2' />
        {{ $t('helper.save') }}
      </ic-button>
      </template>
    </div>


    <h3
      v-if='showShareSection'
      class='font-500 pt-5'
    >
      Багцийн график
    </h3>
    <div v-if='showShareSection'
         class='auth-page-section d-flex flex-column'>
      <loader-block v-if='loadingStatus' :loading='true' />
      <balance-graphic v-else :data='shareBalance' />
    </div>

    <b-modal
      id='income-modal'
      hide-header
      hide-footer
      :body-bg-variant='bodyBgVariant'
      :body-text-variant='bodyTextVariant'
    >
      <div>
        <h4>{{ $t('account.nominalIncome') }}</h4>
        <br />
        <table
          class='table-bordered income'
          style='width: 100%; margin-bottom: 1rem'
        >
          <tr>
            <td style='padding: 0.75rem'>{{ $t('account.bankName') }}</td>
            <td style='padding: 0.75rem'>{{ $t('account.bankTDB') }}</td>
          </tr>
          <tr>
            <td style='padding: 0.75rem'>
              {{ $t('account.accountNumber') }}
            </td>
            <td style='padding: 0.75rem'>495086732</td>
          </tr>
          <tr>
            <td style='padding: 0.75rem'>{{ $t('account.accountName') }}</td>
            <td style='padding: 0.75rem'>{{ $t('account.brokerName') }}</td>
          </tr>
          <tr>
            <td style='padding: 0.75rem'>{{ $t('account.info') }}</td>
            <td style='padding: 0.75rem'>{{ $t('account.infoValue') }}</td>
          </tr>
        </table>
        <span>{{ $t('account.description') }}</span>
      </div>
    </b-modal>
  </div>
</template>
<style>
.balanceRow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  justify-content: space-between;
}
</style>
<script charset='utf-8'>
import PageLayout from '../components/PageLayout'
import BalanceCard from '../components/BalanceCard'
import BalanceGraphic from '../components/BalanceGraphic'
import { mapState, mapGetters } from 'vuex'
import { generateCSV } from '../components/global/TradeChart/helpers'

export default {
  components: {
    PageLayout,
    BalanceCard,
    BalanceGraphic,
  },
  data() {
    return {
      loading: {
        brands: false,
      },
      downloadDisabled: {
        account: false,
        stock: false,
      },
      loadingStatus: true
    }
  },
  computed: {
    ...mapState('common', ['dark']),
    ...mapGetters([
      'localBalance',
      'remoteBalance',
      'shareBalance',
      'localBalanceLoading',
      'remoteBalanceLoading',
      'shareBalanceLoading'
    ]),
    ...mapGetters('user', [
      'iban'
    ]),
    showShareSection() {
      return this.loadingStatus ||
        (Array.isArray(this.shareBalance) && this.shareBalance.length > 0)
    },
    bodyBgVariant() {
      return this.dark ? 'dark' : 'light'
    },
    bodyTextVariant() {
      return this.dark ? 'light' : 'dark'
    },
  },
  created() {
    // this.$store.dispatch('fetchLocalBalance')
    this.$store.dispatch('fetchRemoteBalance')
    this.$store.dispatch('fetchShareBalance').then(() => {
      this.loadingStatus = false
    })
  },
  methods: {
    showIncome() {
      this.$bvModal.show('income-modal')
    },
    downloadAccountTable() {
      const currentTime = new Date()
      generateCSV(this.$refs.accountTable, `${currentTime.getFullYear()} ${currentTime.getMonth()} ${currentTime.getDate()} ${currentTime.getHours()} ${currentTime.getMinutes()} ${currentTime.getSeconds()} account`)
      this.downloadDisabled.account = true
    },
    downloadStockTable() {
      const currentTime = new Date()
      generateCSV(this.$refs.accountTable, `${currentTime.getFullYear()} ${currentTime.getMonth()} ${currentTime.getDate()} ${currentTime.getHours()} ${currentTime.getMinutes()} ${currentTime.getSeconds()} stock`)
      this.downloadDisabled.stock = true
    },
  },
}
</script>
